import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/utils/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { DataTableDirective } from 'angular-datatables';
import { LoaderService } from 'src/app/utils/services/loader.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-privacy-policy-list',
  templateUrl: './privacy-policy-list.component.html',
  styleUrls: ['./privacy-policy-list.component.scss']
})
export class PrivacyPolicyListComponent implements OnInit {

  private category: string;
  dtOptions: DataTables.Settings = {};
  public allData: any;
  private isDtInitialized: boolean = false;
  public addCatName: string;
  public addCatRoute: string;
  public editCatRoute: string;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;

  constructor(private router: Router, private apiService: ApiService, private toastr: ToastrService,private LoaderService:LoaderService) {}

  

  ngOnInit(): void {
    this.LoaderService.showLoader()
    this.category = this.router.url.split('/')[1];
    // this.content_id = this.router.url.split('/')[2];
    // console.log(this.category);
    if(this.category === "privacy-policy-list") {
      this.addCatName = 'Add Privacy Policy';
      this.addCatRoute = '/privacy-policy';
      this.editCatRoute = '/edit-privacy-policy';
    } 

    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
    };
    this.showItem();
  }

  async showItem() {
    this.LoaderService.showLoader()
    console.log('hi')
    const that = this;
    let catTypeListApi: any;
    if(this.category === "privacy-policy-list") {
      catTypeListApi = this.apiService.privacypolicyList();
    } 
    await catTypeListApi.subscribe((resp: any) => {
      console.log(resp.data);
      that.allData = resp.data;
      if (this.isDtInitialized) {
        this.LoaderService.hideLoader()
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next();
        });
      } else {
        this.LoaderService.hideLoader()
        this.isDtInitialized = true;
        this.dtTrigger.next();
      }
    });
  }
  async deleteItem(id, type) {
    this.LoaderService.showLoader();
  
    // Check if ID is valid
    if (id == undefined || id == '') {
      this.toastr.error('User Id is Invalid');
      return false;
    }
  
    // Using SweetAlert2 for confirmation
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'You won\'t be able to restore this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    });
  
    // If the user confirms the deletion
    if (result.isConfirmed) {
      if (type.split(' ')[0] === 'Internal') {
        let catTypeInDltApi: any;
  
        // Determine the API call based on category
        if (this.category === "news-list") {
          catTypeInDltApi = this.apiService.deleteInternalNewsById(id);
        } else if (this.category === "gmp-list") {
          catTypeInDltApi = this.apiService.deleteInternalGmpById(id);
        } else if (this.category === "regulatory-guidelines-list") {
          catTypeInDltApi = this.apiService.deleteInternalGuidelinesById(id);
        } else if (this.category === "business-list") {
          catTypeInDltApi = this.apiService.deleteInternalBusinessById(id);
        } else if (this.category === "products-services-list") {
          catTypeInDltApi = this.apiService.deleteInternalProductById(id);
        }
  
        // Perform the API call
        await catTypeInDltApi.subscribe((result: any) => {
          if (result.success) {
            this.LoaderService.hideLoader();
            this.toastr.success(result.message);
            this.showItem();
          } else {
            this.LoaderService.hideLoader();
            this.toastr.error(result.message);
          }
        });
      } else if (type.split(' ')[0] === 'External') {
        let catTypeExDltApi: any;
  
        // Determine the API call based on category
        if (this.category === "news-list") {
          catTypeExDltApi = this.apiService.deleteExternalNewsById(id);
        } else if (this.category === "gmp-list") {
          catTypeExDltApi = this.apiService.deleteExternalGmpById(id);
        } else if (this.category === "regulatory-guidelines-list") {
          catTypeExDltApi = this.apiService.deleteExternalGuidelinesById(id);
        } else if (this.category === "business-list") {
          catTypeExDltApi = this.apiService.deleteExternalBusinessById(id);
        } else if (this.category === "products-services-list") {
          catTypeExDltApi = this.apiService.deleteExternalProductById(id);
        }
  
        // Perform the API call
        await catTypeExDltApi.subscribe((result: any) => {
          if (result.success) {
            this.LoaderService.hideLoader();
            this.toastr.success(result.message);
            this.showItem();
          } else {
            this.LoaderService.hideLoader();
            this.toastr.error(result.message);
          }
        });
      }
    } else {
      this.LoaderService.hideLoader(); // If the user cancels the deletion
    }
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }
}
